import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { StartPageCO2Savings } from "../StartPage.types";

function useStartPageCO2Savings(year: number, projectId?: string) {
  const { data, error, isLoading } = useQuery({
    queryKey: urls.startPage.co2Savings.key(year, projectId),
    queryFn: () => fetchStartPageCO2Savings(year, projectId)
  });

  return { data, error, isLoading };
}

async function fetchStartPageCO2Savings(year: number, projectId?: string) {
  const response = await apiWithoutCamelization.get<StartPageCO2Savings>(
    urls.startPage.co2Savings.url(year, projectId)
  );
  return response.data;
}

export { useStartPageCO2Savings };
